import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import angular from 'angular';

export const BannerDirectiveModule = angular.module('acme.common.directive.banner', [
  ThemesServiceModule
])
.directive('banner', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/banner/banner.tpl.html',
      scope: {
        heading: '@',
        caption: '@',
        captionKey: '@',
        showButton: '@',
        buttonAction: '&?',
        buttonText: '@',
        buttonSecondaryText: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$sce', 'ThemesService', function($scope, $sce, ThemesService) {

        $scope.banner = {
          showButton: false,
          showMultipleButtons: false,
          theme: ThemesService,

          init: function() {
            if ($scope.showButton === true || $scope.showButton === 'true') {
              this.showButton = true;
            }

            if ($scope.buttonText && $scope.buttonSecondaryText) {
              this.showButton = false;
              this.showMultipleButtons = true;
            }

            this.getHeadingAndCaption();
          },

          getHeadingAndCaption: function() {
            this.heading = $sce.trustAsHtml($scope.heading);
            this.caption = $sce.trustAsHtml($scope.caption);
          }
        };

        $scope.banner.init();

      }]

    };

}]).name;